<template>
  <div class="spinner">
    <i class="si si-spinner si-spin"></i>
  </div>
</template>

<script lang="js">

export default {
  name: 'sbxSpinner',
};
</script>

<style lang="scss" scoped>
@import '../../scss/variables';
@import '../../scss/smartbox-icons';

.spinner {
  display: flex;
  justify-content: center;
  font-size: rem-calc(40);
  color: #393939;
}
</style>
